var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"switcher switcher__wrapper"},[_c('div',{staticClass:"switcher__box",class:{
      'switcher__box_anabled': _vm.value,
      'switcher_inactive': this.isInactive,
      'switcher_disabled': this.isDisabled,
    },on:{"click":_vm.toggleHandler}},[_c('div',{staticClass:"switcher__toggle"}),_c('div',{staticClass:"switcher__text"},[_vm._v(_vm._s(_vm.currentText))])]),(_vm.isCommentable)?_c('Comments',{attrs:{"uuid":_vm.uuid,"can-comment":_vm.canComment,"commentTo":_vm.commentTo,"on-top":""}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }